import { useGetAllFeatureFlags } from "@/contexts/FeatureFlagContext"
import { HelpdeskLink } from "@/features/helpdesk"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { CustomerStudioCard } from "./CustomerStudioCard"
import { MasterDataCard } from "./MasterDataCard"
import { RadarBanner } from "./RadarBanner"
import { SupplierStudioCard } from "./SupplierStudioCard"

/**
 * Material Compliance start page (flag MC_HOME). Hero answers "where do I
 * stand?", the studio cards answer "where do I work?". Each card container
 * owns its stats hooks and is mounted only when its studio flag is enabled,
 * so disabled studios fire no requests.
 */
export function HomePage() {
  const { translate } = useTranslation()
  const flags = useGetAllFeatureFlags()

  return (
    <div className="relative min-h-full overflow-hidden bg-grey3">
      {/* subtle yellow glow, top right (design: radial gradient at 5% alpha).
          Lives on this full-height/full-width wrapper (not the max-w content
          column below) so the clip region always matches the actual page
          bounds instead of the column's content-sized box — otherwise the
          glow gets hard-clipped short of the real page edges on tall/short
          viewports. */}
      <div className="pointer-events-none absolute -top-32 right-0 h-[420px] w-[720px] rounded-full bg-yellow1/5 blur-3xl" />

      <div className="relative mx-auto max-w-[1460px] px-9 pb-14 pt-8">
        <div className="relative mb-7">
          {/* raw h1 is the MC module idiom (ModuleHeader.tsx) */}
          <h1 className="text-[35px] font-normal leading-tight text-white">
            {translate("MC_HOME_TITLE")}
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-grey5">
            {translate("MC_HOME_SUBTITLE")}
          </p>
          <HelpdeskLink
            categoryId="master-data"
            articleId="erste-schritte"
            className="mt-2"
          />
        </div>

        <div className="relative grid grid-cols-1 gap-[18px] lg:grid-cols-3">
          {flags.MC_MASTER_DATA && <MasterDataCard />}
          {flags.MC_SUPPLIER_STUDIO && <SupplierStudioCard />}
          {flags.MC_CUSTOMER_STUDIO && <CustomerStudioCard />}
        </div>

        <RadarBanner />
      </div>
    </div>
  )
}
